import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// 画面遷移（ログイン後の遷移を含む）で、前の画面のスクロール位置が残らないよう先頭へ戻す。
// 同じ画面内のクエリ・state更新（検索条件の反映やメッセージを閉じる操作）では位置を保つため、
// pathname が変わった時だけ実行する。ブラウザの戻る/進む（POP）はブラウザ側の位置復元に任せる。
export const useScrollToTopOnNavigate = (): void => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const previousPathname = useRef(pathname);
  useEffect(() => {
    if (previousPathname.current === pathname) return;
    previousPathname.current = pathname;
    if (navigationType !== "POP") window.scrollTo(0, 0);
  }, [pathname, navigationType]);
};
